module.exports = __webpack_public_path__ + "img/IMG_8981_L_BlackMatted.519db622.jpg";